import type { ReactNode } from 'react';

export const symbol_split_scene_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-120q-24 0-42-18t-18-42v-180q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v180h520v-180q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v180q0 24-18 42t-42 18H220ZM110-450q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-510 110-510h50v-270q0-24 18-42t42-18h520q24 0 42 18t18 42v270h50q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H110Zm110-60h520v-270H220v270Zm520 330H220h520Zm0-600H220h520Z"
		/>
	</svg>
);
